import { useCallback, useState } from 'react';

interface IUseLoadingHook {
  isLoading: boolean;
  handleLoadingStart: () => void;
  handleLoadingEnd: () => void;
  toggleLoading: () => void;
  setLoading: (value: boolean) => void;
}

export function useLoading(initialState = false): IUseLoadingHook {
  const [isLoading, setLoading] = useState(initialState);

  const handleLoadingEnd = useCallback(() => {
    setLoading(false);
  }, [setLoading]);

  const handleLoadingStart = useCallback(() => {
    setLoading(true);
  }, [setLoading]);

  const toggleLoading = useCallback(() => {
    setLoading(!isLoading);
  }, [isLoading, setLoading]);

  return {
    handleLoadingEnd,
    handleLoadingStart,
    isLoading,
    setLoading,
    toggleLoading,
  };
}

